<div class="statusbar screen-element" [ngClass]="{'debug':debug}">	
<div class="current-time" [ngClass]="{'debug':debug}" >{{ getIoService().getCurrentTime() | date: "HH:mm" }}</div>
	<iconbar class="screen-element" [debug]="debug"></iconbar>
	<div class="current-temperature" [ngClass]="{'debug':debug}">{{ outdoorTempSensor.toString() }}</div>
</div>